"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_idle_timer_1 = __importDefault(require("react-idle-timer"));

exports.IdleTracker = react_1.default.memo(function (_a) {
  var children = _a.children,
      timeout = _a.timeout,
      onIdleHandler = _a.onIdleHandler,
      onActiveHandler = _a.onActiveHandler;
  return react_1.default.createElement(react_idle_timer_1.default, {
    timeout: timeout,
    onIdle: onIdleHandler,
    onActive: onActiveHandler
  }, children);
});